export const environment = {
    production: true,
    apiHost: '',
    basePath: 'https://api.seldit.com/api/v1',
    accessKey: '3QQkXVPMwWdEFSA',
    storefrontBaseUrl: '',
    firebaseConfig: {
        apiKey: 'AIzaSyDlDFtMXVMmTBaA_X2bseZSiXMFyXkdzrA',
        authDomain: 'seldit-82226.firebaseapp.com',
        projectId: 'seldit-82226',
        storageBucket: 'seldit-82226.firebasestorage.app',
        messagingSenderId: '716674014742',
        appId: '1:716674014742:web:22ff35fab3545aa85f5f37',
        measurementId: 'G-D37TNBB5S4',
    },
    turnstileSiteKey: '0x4AAAAAADLPyqoWMW42u07i',
    googleFontApiKey: 'AIzaSyBPWObqUe5CJvRqztBSAAqqEvzCw9UyzWU',
    // PrimeUI Community license for PrimeNG 22 — without it every screen shows an
    // "Invalid PrimeUI License" badge. It is checked offline and ships in the bundle.
    primeuiLicenseKey:
        'eyJpZCI6IjZiYWRmMWQ5LTU5MDMtNDRmOC05ODQxLTM1MGY4OGY0MzA4ZCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODk5ODk2MTIsImV4cCI6MTgyMTUyNTYxMn0.E7MQIWKkLkLcXOHwHWQeZPNCjetvZv8wbexDWqchy33gUPQQk-5G6lRsAFdqiBnoDuedMZ1UuLYqkzpoXj-iBg',
};
